import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { EPISODE_ACTIVITIES_REFERENCE_DATA_URL } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getActivitiesReferenceData = createAsyncThunk(
  'stop/getActivitiesReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(EPISODE_ACTIVITIES_REFERENCE_DATA_URL, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const activitiesReferenceSlice = createSlice({
  name: 'stop/activitiesReference',
  initialState: null,
  reducers: {
    resetActivitiesReference: () => null,
  },
  extraReducers: {
    [getActivitiesReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetActivitiesReference } = activitiesReferenceSlice.actions;

export default activitiesReferenceSlice.reducer;
